import React from "react";

import { PAGE_SIZE_OPTIONS } from "constants/constants";

import { UPLOAD_HISTORY_COPY } from "../../constants/uploadsContent";
import styles from "./FileUploadsHistory.module.scss";

const UploadHistoryPagination = ({
  currentPage,
  totalPages,
  pageSize,
  startIndex,
  endIndex,
  totalRows,
  onPreviousPage,
  onNextPage,
  onPageChange,
  onPageSizeChange,
}) => (
  <div className={styles.pagination}>
    <span className={styles.pageInfo}>
      {UPLOAD_HISTORY_COPY.PAGINATION_SHOWING(startIndex, endIndex, totalRows)}
    </span>

    <div className={styles.pageControls}>
      <button
        type="button"
        className={styles.pageBtn}
        disabled={currentPage <= 1}
        onClick={onPreviousPage}
      >
        {UPLOAD_HISTORY_COPY.PAGINATION_PREVIOUS}
      </button>

      {Array.from({ length: Math.min(totalPages, 5) }, (_, index) => {
        const pageNumber = index + 1;

        return (
          <button
            key={pageNumber}
            type="button"
            className={`${styles.pageBtn} ${
              pageNumber === currentPage ? styles.pageBtnActive : ""
            }`}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        );
      })}

      <button
        type="button"
        className={styles.pageBtn}
        disabled={currentPage >= totalPages}
        onClick={onNextPage}
      >
        {UPLOAD_HISTORY_COPY.PAGINATION_NEXT}
      </button>

      <select
        className={styles.pageSizeSelect}
        value={pageSize}
        onChange={(event) => onPageSizeChange(Number(event.target.value))}
      >
        {PAGE_SIZE_OPTIONS.map((size) => (
          <option key={size} value={size}>
            {UPLOAD_HISTORY_COPY.PAGE_SIZE_SUFFIX(size)}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default UploadHistoryPagination;
